var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindSpeedM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "4nz2reqx6a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.117647 0 0 0 0 0.141176 0 0 0 0 0.278431 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-300 -569) translate(285 558) translate(15 11)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#4nz2reqx6a)",
    transform: "translate(-300 -569) translate(285 558) translate(15 11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.8)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#303030",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.618
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.48,
    cy: 3.564,
    rx: 1.581,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.898 3.564L10.413 8.386 10.977 9.044 14.139 9.044 14.751 8.361 14.061 3.564M10.425 8.264L14.644 8.286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.127 4.024l3.338-.46s.804-.204.818-.77M14.27 5.013c.124-.018 3.3-.427 3.3-.427s.779-.053.805.778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.112 4.642c.315 1.528 1.633 2.677 3.207 2.677 1.814 0 3.284-1.522 3.284-3.395 0-1.872-1.47-3.388-3.284-3.388-1.714 0-3.125 1.359-3.265 3.085M10.726 4.333L7.536 4.788M10.603 5.557L7.512 5.808M7.512 5.808C7.238 7.47 5.815 8.73 4.095 8.73c-1.913 0-3.47-1.575-3.47-3.517 0-1.947 1.557-3.522 3.47-3.522 1.779 0 3.237 1.353 3.44 3.097"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.114,
    cy: 5.211,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.273 9.044L11.877 10 13.114 10 13.821 9.044M12.028 10H13.028V13.491H12.028zM22.106 2.63s.926 1.525-.17 2.835M21.283 6.035s-.314.153-.596.164"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 4.08,
    cy: 5.25,
    r: 2.587,
    stroke: "#303030",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.618
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#303030",
    fillRule: "nonzero",
    d: "M4.08 5.975c-.82 0-1.509-.54-1.746-1.283-.057.177-.096.362-.096.558 0 1.018.825 1.842 1.842 1.842 1.018 0 1.842-.824 1.842-1.842 0-.196-.039-.38-.095-.558-.238.742-.925 1.283-1.747 1.283z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindSpeedM);
export default __webpack_public_path__ + "static/media/wind-speed-m.45ab0640.svg";
export { ForwardRef as ReactComponent };